var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{class:`border border-dark ${this.className} darken-2 rounded-lg py-2 px-3 white--text text-body-1`},[_vm._v(" "+_vm._s(_vm.taskStatus)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }